import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';

export const Transition = () => {
  return (
    <div className="min-h-[calc(100vh-64px)]" data-testid="chapter-transition">
      <article className="max-w-2xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <header className="mb-16 animate-fade-in">
          <p className="text-xs font-sans font-medium tracking-widest uppercase text-stone-400 mb-4">
            Chapter
          </p>
          <h1 className="font-serif font-light text-3xl md:text-4xl lg:text-5xl text-stone-800 tracking-tight leading-[1.2]">
            Transition
          </h1>
        </header>

        <div className="prose-living space-y-8 animate-fade-in-delay-1">
          <p>
            Transitions rarely announce themselves clearly. 
            One day you're in the middle of things. 
            The next, you realize something has shifted.
          </p>

          <p>
            A move. A loss. A new role. A change in health. 
            A door that closed. A door that opened.
          </p>

          <p>
            This chapter is for the in-between — 
            the space where what was and what will be haven't quite met.
          </p>

          <div className="py-8 border-t border-b border-stone-100 my-12 space-y-6">
            <h2 className="font-serif text-xl text-stone-700">
              Thoughts for the passage:
            </h2>
            <ul className="space-y-4 text-stone-600">
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">—</span>
                <span>What are you leaving behind?</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">—</span>
                <span>What are you carrying forward?</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">—</span>
                <span>What feels uncertain right now?</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">—</span>
                <span>What would help you feel more grounded during this change?</span>
              </li>
            </ul>
          </div>

          <p>
            Transitions don't have to be survived. 
            They can be walked through — slowly, carefully, 
            with attention to what matters.
          </p>

          <p>
            This space is for pausing in the middle 
            and noticing what needs to be noticed.
          </p>
        </div>

        <nav className="mt-16 pt-8 border-t border-stone-100 animate-fade-in-delay-2">
          <p className="text-sm font-sans text-stone-400 mb-4">Explore other chapters</p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/living-book/chapters/responsibility"
              className="inline-flex items-center gap-2 px-4 py-2 bg-stone-100 hover:bg-stone-200 rounded-full text-sm font-sans text-stone-600 transition-colors"
              data-testid="chapter-link-responsibility"
            >
              <BookOpen className="w-4 h-4" strokeWidth={1.5} />
              Responsibility
            </Link>
            <Link
              to="/living-book/chapters/longevity"
              className="inline-flex items-center gap-2 px-4 py-2 bg-stone-100 hover:bg-stone-200 rounded-full text-sm font-sans text-stone-600 transition-colors"
              data-testid="chapter-link-longevity"
            >
              <BookOpen className="w-4 h-4" strokeWidth={1.5} />
              Longevity
            </Link>
            <Link
              to="/living-book/chapters/legacy"
              className="inline-flex items-center gap-2 px-4 py-2 bg-stone-100 hover:bg-stone-200 rounded-full text-sm font-sans text-stone-600 transition-colors"
              data-testid="chapter-link-legacy"
            >
              <BookOpen className="w-4 h-4" strokeWidth={1.5} />
              Legacy
            </Link>
          </div>
        </nav>
      </article>
    </div>
  );
};

export default Transition;
